"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var typography_1 = require("../typography");
var ProgressBarContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition !== 'top' && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n    "], ["\n      display: flex;\n      align-items: center;\n    "])));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'right' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-direction: row-reverse;\n    "], ["\n      flex-direction: row-reverse;\n    "])));
});
var StyledProgressBar = styled_components_1.default.div.attrs(function (_a) {
    var progress = _a.progress;
    return ({
        role: 'progressbar',
        'aria-valuenow': progress,
        'aria-valuemin': 0,
        'aria-valuemax': 100,
    });
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 10px;\n  position: relative;\n  border-radius: 25px;\n\n  &::before,\n  &::after {\n    border-radius: inherit;\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  &::before {\n    width: 100%;\n    border-color: ", ";\n  }\n\n  &::after {\n    width: ", ";\n    background: ", ";\n    border-color: ", ";\n    transition: width 0.4s ease-out;\n\n    ", "\n  }\n"], ["\n  width: 100%;\n  height: 10px;\n  position: relative;\n  border-radius: 25px;\n\n  &::before,\n  &::after {\n    border-radius: inherit;\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  &::before {\n    width: 100%;\n    border-color: ", ";\n  }\n\n  &::after {\n    width: ", ";\n    background: ", ";\n    border-color: ", ";\n    transition: width 0.4s ease-out;\n\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.border.primary;
}, function (_a) {
    var progress = _a.progress;
    return "".concat(progress, "%");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border.primary;
}, function (_a) {
    var progress = _a.progress;
    if (progress === 0) {
        return "\n          opacity: 0;\n        ";
    }
});
var ProgessBarLabel = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        sizes: [theme.typography.fontSizes.fontSize14],
    });
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var labelPosition = _a.labelPosition;
    if (labelPosition === 'top') {
        return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        margin-bottom: 6px;\n      "], ["\n        margin-bottom: 6px;\n      "])));
    }
    else if (labelPosition === 'left') {
        return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        margin-right: 12px;\n        flex-shrink: 0;\n      "], ["\n        margin-right: 12px;\n        flex-shrink: 0;\n      "])));
    }
    else {
        return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        margin-left: 12px;\n        flex-shrink: 0;\n      "], ["\n        margin-left: 12px;\n        flex-shrink: 0;\n      "])));
    }
});
/**
 * A progress bar used for indicating progression through a given flow.
 */
var ProgressBar = function (_a) {
    var progress = _a.progress, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'top' : _b;
    // Just in case the provided `progress` is below 0 or above 100
    var progressPercentage = Math.round(Math.min(100, Math.max(0, progress)));
    return (react_1.default.createElement(ProgressBarContainer, { labelPosition: labelPosition },
        label ? (react_1.default.createElement(ProgessBarLabel, { id: "progress-bar-label", labelPosition: labelPosition }, label)) : null,
        react_1.default.createElement(StyledProgressBar, { progress: progressPercentage, "aria-labelledby": label ? 'progress-bar-label' : undefined })));
};
exports.ProgressBar = ProgressBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
